import { useEffect, useRef } from "react";
import { createMatchSnapshotSseClient } from "../services/live/matchSnapshotSseClient.js";

export default function useMatchSnapshotsSSE({
  streamUrl,
  enabled = true,
  onSnapshot,
  onResync,
}) {
  const snapshotRef = useRef(onSnapshot);
  const resyncRef = useRef(onResync);
  const disconnectedRef = useRef(false);
  const lastResyncRef = useRef(0);

  snapshotRef.current = onSnapshot;
  resyncRef.current = onResync;

  useEffect(() => {
    if (!enabled || !streamUrl) return undefined;
    const requestResync = () => {
      const now = Date.now();
      if (now - lastResyncRef.current < 15000) return;
      lastResyncRef.current = now;
      resyncRef.current?.();
    };

    const client = createMatchSnapshotSseClient({
      url: streamUrl,
      onConnected: () => {
        if (disconnectedRef.current) requestResync();
        disconnectedRef.current = false;
      },
      onSnapshot: (match) => snapshotRef.current?.(match),
      onError: () => {
        disconnectedRef.current = true;
      },
    });
    const onFocus = () => requestResync();
    window.addEventListener("focus", onFocus);
    return () => {
      window.removeEventListener("focus", onFocus);
      client.close();
    };
  }, [enabled, streamUrl]);
}

